import * as React from 'react';

function SentimentBlockIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width={24} height={24} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
			<text
				transform="translate(0 -2)"
				fill="#6C7680"
				fillRule="evenodd"
				fontFamily="AppleColorEmoji, Apple Color Emoji"
				fontSize={22}
			>
				<tspan x={0} y={23}>
					{'\uD83D\uDE03'}
				</tspan>
			</text>
		</svg>
	);
}

export default SentimentBlockIcon;
